import { Controller } from "@hotwired/stimulus"
import { distanceOfTimeInWords, waitingLabel } from "../lib/relative_time"

// Keeps a relative time label current while the page stays open, so a task
// list or workflow left on screen for an hour still reads right. The server
// renders the same wording for the first paint (ApplicationHelper#relative_time_tag).
//
// Usage: <time datetime="2026-09-02T12:00:00Z" data-controller="relative-time"
//              data-relative-time-format-value="ago|waiting|retry">…</time>
//   ago     → "about 2 hours ago" (strip-about removes the "about ")
//   waiting → "3d 2h" with an optional prefix such as "waiting "
//   retry   → "in about 5 minutes" until the time passes, then "shortly"
export default class extends Controller {
  static values = {
    format: { type: String, default: "ago" },
    prefix: { type: String, default: "" },
    stripAbout: { type: Boolean, default: false },
    interval: { type: Number, default: 30000 }
  }

  connect() {
    this.render()
    this.timer = setInterval(() => this.render(), this.intervalValue)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  render() {
    const at = Date.parse(this.element.getAttribute("datetime"))
    if (Number.isNaN(at)) return

    const now = Date.now()
    let text
    switch (this.formatValue) {
      case "waiting":
        text = `${this.prefixValue}${waitingLabel(at, now)}`
        break
      case "retry":
        text = at > now ? `in about ${distanceOfTimeInWords(now, at)}` : "shortly"
        break
      default: {
        const distance = distanceOfTimeInWords(at, now)
        text = `${this.stripAboutValue ? distance.replace(/^about /, "") : distance} ago`
      }
    }

    if (this.element.textContent !== text) this.element.textContent = text
  }
}
